import React, { useState } from 'react';
import { useOverrides } from '@quarkly/components';
import { Box, Link, Text, Image } from '@quarkly/widgets';
const overrides = {
	'Link': {
		kind: 'Link'
	},
	'Link :default': {
		kind: 'Link'
	},
	'image': {
		kind: 'Image'
	},
	'Link :hover': {
		kind: 'Link'
	},
	'image': {
		kind: 'Image',
		width: '7px',
		height: '12px'
	},
	'Before image': {
		kind: 'Image',
		width: '7px',
		height: '12px'
	},
	'Before image :default': {
		kind: 'Image',
		width: '7px',
		height: '12px'
	},
	'Before image :hover': {
		kind: 'Image',
		width: '7px',
		height: '12px'
	},
	'Before Text': {
		kind: 'Text',
		props: {
			display: 'inline-block',
			color: 'red'
		}
	},
	'Before Text2': {
		kind: 'Text',
		props: {
			color: '#fff'
		}
	},
	'Before Text3': {
		kind: 'Text',
		props: {
			color: '#fff',
			children: 'Посмотреть'
		}
	},
	'Before Text2 :default': {
		kind: 'Text',
		props: {
			color: '#fff'
		}
	},
	'Before Text3 :default': {
		kind: 'Text',
		props: {
			color: '#fff',
			children: 'Посмотреть'
		}
	},
	'Before Text2 :hover': {
		kind: 'Text',
		props: {
			color: '#fff'
		}
	},
	'Before Text3 :hover': {
		kind: 'Text',
		props: {
			color: '#fff',
			children: 'Посмотреть'
		}
	}
};

const CardHoverButton = props => {
	const {
		override,
		children,
		rest
	} = useOverrides(props, overrides, {});
	const [isHover, setHover] = useState(false);

	const onCardEnter = () => {
		setHover(true);
	};

	const onCardLeave = () => {
		setHover(false);
	};

	return <Box onMouseEnter={onCardEnter} onMouseLeave={onCardLeave} {...rest}>
		      
		{children}
		      
		<Text {...override('Before Text2', `Before Text2 :${isHover ? 'hover' : 'default'}`)}>
			        
			{override('Before Text2').children || 'Посмотреть ❯'}
			      
		</Text>
		      
		<Link {...override('Link', `Link :${isHover ? 'hover' : 'default'}`)}>
			 
			<Image {...override('Before image', `Before image :${isHover ? 'hover' : 'default'}`)} />
			      
			<Text {...override('Before Text3', `Before Text3 :${isHover ? 'hover' : 'default'}`)} />
			      
		</Link>
		    
	</Box>;
};

Object.assign(CardHoverButton, {
	overrides
});
export default CardHoverButton;